// removed by extract-text-webpack-plugin
module.exports = {"container":"container-2WZkr container-3Sdxl","title":"title-1DCar title-1DYMu","subhead":"subhead-2g7No subhead-1DadN","input":"input-1DWXj input-y5omh","link":"link-3qAM_ link-1i3sH","select":"select-1wUHX select-2KNWi","text":"text-1MnKG","well":"well-1rFst","pageLoader":"pageLoader-1A7HF pageLoader-NhcRr","deleting":"deleting-3JiLx","planDetails":"planDetails-2S6FC","autoRenewNote":"autoRenewNote-2X6zY","error":"error-3WYtK","loadingError":"loadingError-20s4f well-1rFst error-3WYtK","success":"success-1Oi1b","autoRenewalLoading":"autoRenewalLoading-2dFkb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_subscriptionSettings.css
// module id = 1250
// module chunks = 1